
import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { LanguageContext } from "../context/LanguageContext";
import { es } from 'date-fns/locale';
import { format } from "date-fns";
import DatePicker from "react-datepicker";

import axios from "axios";
import { apiClient } from "../api";

const NewShiftForm = () => {
  const { t } = useContext(LanguageContext);
  const navigate = useNavigate();
  const handleGoBack = () => navigate(-1);

  const user = JSON.parse(localStorage.getItem("user"));
  const company = JSON.parse(localStorage.getItem("company"));

  // 🔧 helper: Date -> "HH:mm:00"
  const formatTime = (date) => {
    if (!date) return null;
    const h = String(date.getHours()).padStart(2, "0");
    const m = String(date.getMinutes()).padStart(2, "0");
    return `${h}:${m}:00`;
  };

  // (Opcional) calcula horas en cliente para mostrar al usuario
  const diffHoursDecimalClient = (d1, d2) => {
    if (!d1 || !d2) return 0;
    const toMin = (d) => d.getHours() * 60 + d.getMinutes();
    let a = toMin(d1);
    let b = toMin(d2);
    if (b < a) b += 24 * 60; // cruza medianoche
    return Number(((b - a) / 60).toFixed(2));
  };

  const [idShift, setIdShift] = useState("");
  const [timeBegin, setTimeBegin] = useState(null); // 👈 Date o null
  const [timeEnd, setTimeEnd] = useState(null);     // 👈 Date o null
  const [observations, setObservation] = useState("");

  const totalHrShiftPreview = diffHoursDecimalClient(timeBegin, timeEnd);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const payload = {
        id_c: company?.id_c,
        id_shift: idShift,
        time_begin: formatTime(timeBegin), // "HH:mm:00"
        time_end: formatTime(timeEnd),     // "HH:mm:00"
        observations,
        id_user: user?.id_u
        // ❌ NO enviamos total_hr_shift: el backend lo calcula
      };

      await apiClient.post("/turnos", payload); // ✅ endpoint correcto
      alert("✅ Turno registrado exitosamente");
      handleGoBack();
    } catch (error) {
      console.error("❌ Error al registrar turno:", error);
      alert("Ocurrió un error al registrar el turno.");
    }
  };


  return (
    <div className="box1">
      <div className="box9">

        <p>{t("shifts4")}</p>
        <form onSubmit={handleSubmit}>
          <table className="form1">
            <tbody>

             {/*}
              <tr>
                <td><label htmlFor="idShift">{t("shifts1")}</label></td>
                <td>
                  <select
                    className="input1"
                    value={idShift}
                    onChange={(e) => setIdShift(e.target.value)}
                    id="idShift"
                    name="idShift"
                    required
                  >
                    <option value="" disabled>--</option>
                    {[...Array(10)].map((_, i) => (
                      <option key={i+1} value={i+1}>{i+1}</option>
                    ))}
                  </select>
                </td>
              </tr>
 */}
<tr>
       
                <td><label htmlFor="cod_producto">{t("shifts1")}</label></td>
                <td>
                  <input
                    className="input1"
                    type="text"
                    value={idShift}
                    onChange={(e) => setIdShift(e.target.value)}
                    id="idShift"
                    name="idShift"
                    required
                  />
                </td>
           
</tr>


              <tr>
                <td><label htmlFor="time_ini">{t("batchList8")}</label></td>
                <td>
                  <DatePicker
                    selected={timeBegin}
                    onChange={(date) => setTimeBegin(date)}
                    showTimeSelect
                    showTimeSelectOnly
                    timeIntervals={5}
                    timeCaption="Hora"
                    dateFormat="HH:mm"
                    timeFormat="HH:mm"
                    locale={es}
                    placeholderText="Selecciona hora"
                    className="input1"
                    id="time_ini"
                    name="time_ini"
                    required
                  />
                </td>
              </tr>

              <tr>
                <td><label htmlFor="time_fin">{t("batchList10")}</label></td>
                <td>
                  <DatePicker
                    selected={timeEnd}
                    onChange={(date) => setTimeEnd(date)}
                    showTimeSelect
                    showTimeSelectOnly
                    timeIntervals={5}
                    timeCaption="Hora"
                    dateFormat="HH:mm"
                    timeFormat="HH:mm"
                    locale={es}
                    placeholderText="Selecciona hora"
                    className="input1"
                    id="time_fin"
                    name="time_fin"
                    required
                  />
                </td>
              </tr>

              <tr>
                <td><label htmlFor="observations">{t("shifts2")}</label></td>
                <td>
                  <textarea
                    className="input1"
                    id="observations"
                    name="observations"
                    rows="3"
                    value={observations}
                    onChange={(e) => setObservation(e.target.value)}
                    required
                  />
                </td>
              </tr>

              {/* Vista previa opcional de horas calculadas */}
              {timeBegin && timeEnd && (
                <tr>
                  <td><b>{t("Duración (h)")}</b></td>
                  <td><b>{totalHrShiftPreview}</b></td>
                </tr>
              )}
            </tbody>
          </table>

          <button type="submit" className="button7">{t("prodList12")}</button>
          <button type="button" className="button7" onClick={handleGoBack}>
            {t("prodList13")}
          </button>
        </form>
      </div>
    </div>
  );
};

export default NewShiftForm;
